{
  "terms_of_service": {
    "title": "Terms of Service",
    "version": "2026-03-24",
    "last_updated": "March 24, 2026"
  },
  "privacy_policy": {
    "title": "Privacy Policy",
    "version": "2026-03-24",
    "last_updated": "March 24, 2026"
  }
}
